(function () {
  function initSearch(el) {
    const input = el.querySelector("[data-neb-search-input]");
    if (!input) return;

    let placeholders = [];
    try {
      placeholders = JSON.parse(input.getAttribute("data-placeholders") || "[]");
    } catch (e) {}

    if (!placeholders.length) return;

    let i = 0;
    let timer = null;

    const tick = () => {
      // Don’t change placeholder while typing or focused
      if (document.activeElement === input) return;
      if ((input.value || "").trim().length > 0) return;

      i = (i + 1) % placeholders.length;
      input.setAttribute("placeholder", placeholders[i]);
    };

    const start = () => {
      if (timer) return;
      timer = window.setInterval(tick, 2200);
    };

    const stop = () => {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    };

    input.addEventListener("focus", stop);
    input.addEventListener("blur", start);
    input.addEventListener("input", () => {
      // if user clears text, allow cycling again
      if ((input.value || "").trim().length === 0) start();
      else stop();
    });

    start();
  }

  function boot() {
    document.querySelectorAll("[data-neb-search]").forEach(initSearch);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();